import { apiSlice } from "../../../api/ApiService";
import { getHeadersFromRedux } from "../../../utility/functions/common-functions";

const postUserPreferenceApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    postUserPrefernce: builder.mutation({
      query: (body) => {
        const headers = getHeadersFromRedux();
        return {
          url: `/api/v1/PatientPreference/user-preference`,
          method: "POST",
          data: body,
          headers,
        };
      },
      invalidatesTags: (result, error) => [
        { type: "UserPreference" },
      ],
    }),
  }),
  overrideExisting: false,
});

export const { usePostUserPrefernceMutation } = postUserPreferenceApi;
export default postUserPreferenceApi;
